import { Identifier, useGetList } from "react-admin";
import { filter } from "../../common/components/utils/fn";

export const getFilterValues = (filterValuesReceive: any, tab: string, projectId: Identifier) => {
    let filterValues = { ...filterValuesReceive };
    delete filterValues["project_delegates"];
    delete filterValues["_not"];
    if (tab === "mydelegate") {
        filterValues["project_delegates"] = filter("projectId", projectId);
    } else {
        filterValues["_not"] = filter("project_delegates.projectId", projectId);
    }
    return filterValues;
}

const useTotal = (filterValuesReceive: any, value: string, projectId: Identifier): number => {
    const filterValues = getFilterValues(filterValuesReceive, value, projectId);
    const { total } = useGetList(
        'user',
        { perPage: 1, page: 1 },
        { field: 'id', order: 'ASC' },
        filterValues
    );
    return total;
};

export const useGetTotals = (filterValues: any, projectId: Identifier): { mydelegate: number, others: number } => {
    return {
        mydelegate: useTotal(filterValues, "mydelegate", projectId),
        others: useTotal(filterValues, "others", projectId)
    };
};